import { Heading } from '@core/ui';
import { Link } from '@online-webinar/ui-frontend';
import { useTranslation } from 'react-i18next';

export const VerificationSucceded = () => {
    const { t } = useTranslation();
    return (
        <>
            <Heading variant="h2" classNames={`mb-4`}>
                {t('Account.Verification.Succeeded.Subheading')}
            </Heading>
            <div className="text-xl">{t('Account.Verification.Succeeded.Text')}</div>
            <div className="my-4">
                <Link to="/login" variant="primary">
                    {t('Account.Button.Login')}
                </Link>
            </div>
        </>
    );
};
